import apiClient from './axios';
import { normalizeSearchTerm } from './search';

export async function fetchUsers({ offset = 0, limit = 50, search = '' } = {}) {
  // console.log(`fetchUsers ${offset} to ${offset+limit}`);
  const normalizedSearch = normalizeSearchTerm(search);

  const res = await apiClient.get('/v3/user', {
    params: { 
      offset: offset, 
      limit: limit,
      search: normalizedSearch || undefined,
    },
  });

  // console.log(`fetchUsers -> ${ JSON.stringify( res, null, 2 )}`);

  return res;
}

export async function updateUserEmail({ uuid, email, password }) {
  const res = await apiClient.patch('/v3/user', { uuid, email, password });

  return res.data;
}

export async function sendTemporaryPassword({ username, email }) {
  const res = await apiClient.post('/v3/user/inquire/password', {
    username,
    email,
  });

  return res.data;
}

export async function deleteUser(uuid) {
  const res = await apiClient.delete('/v3/user', {
    data: { uuid },
  });
  
  return res.data;
}
